/* istanbul ignore file */
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';
import { useEmployeeContractUrl } from 'domain/people/employee/contracts/employeeContractRouting';

const ViewEmployeeContractButton = (props: Omit<LinkButtonProps, 'children' | 'url'>) => {
  const { getSingleEntityUrl } = useEmployeeContractUrl();

  return (
    <LinkButton {...props} size="small" variant="outlined" url={getSingleEntityUrl}>
      View
    </LinkButton>
  );
};

export default ViewEmployeeContractButton;
